import { Affiliate } from 'models/Integrations';
import useFetchAgencyIntegrationSettings from 'components/domain/integrationSettings/useFetchAgencyIntegrationSettings';
import useAppUser from '../../../../hooks/useAppUser';
import useRefreshOnHostfullyIntegrationEvent from './useRefreshOnHostfullyIntegrationEvent';

const useGuidebooks = () => {
  const { isEmployeeManager } = useAppUser();
  const { integrationSettings, refetch } = useFetchAgencyIntegrationSettings();

  useRefreshOnHostfullyIntegrationEvent({ refreshFn: refetch });

  const isGuidebooksEnabled =
    (isEmployeeManager &&
      integrationSettings?.find(
        ({ affiliateEnum }) => affiliateEnum === Affiliate.HOSTFULLY,
      )?.isEnabled) ||
    false;

  return { isGuidebooksEnabled };
};

export default useGuidebooks;
